// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QAD5","type":"styles_type__J2BZs","choices":"styles_choices__2oaMv"};